define.alias("shared/errors/missing-translation", "settings/errors/missing-translations");